/* src/app/registration/registration-presenter/registration-presenter.component.scss */
label.required::after {
  content: "*";
  color: red;
}
/*# sourceMappingURL=registration-presenter.component.css.map */
